<template>
  <v-card class="mx-auto">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="primary text-h5 text-left white--text"
          ><span>
            Links
            <BaseTooltipButton
              v-if="userHasEditPerms"
              x-small
              @click.stop="$refs.linkForm.addLink()"
              icon="mdi-plus"
              iconColor="secondary"
              buttonClass="white"
              >Add Link
            </BaseTooltipButton>
          </span>
          <template v-slot:actions>
            <v-icon class="white--text">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <div class="viewer" id="note-view">
              <template v-for="l in sortedLinks">
                <div :key="l.ID">
                  <div
                    class="link"
                    :class="
                      l.CreatedByID == currentUser.ID
                        ? ' user-link'
                        : ' non-user-link'
                    "
                    ><a :href="l.link" target="_blank">{{ l.Description }}</a>
                    <div
                      class="user-data"
                      :class="
                        l.CreatedByID == currentUser.ID ? 'user-link' : ''
                      "
                      ><span
                        v-if="l.CreatedBy.FirstName && l.CreatedBy.LastName"
                        >{{ l.CreatedBy.FirstName }}
                        {{ l.CreatedBy.LastName }}</span
                      ><span v-else>
                        {{ l.CreatedBy.Email }}
                      </span>
                      -
                      {{ l.CreatedDate | formatDateTime }}
                      <span v-if="l.CreatedByID == currentUser.ID">
                        <BaseTooltipButton
                          x-small
                          @click="$refs.linkForm.editLink(l)"
                          iconColor="primary"
                          icon="mdi-pencil"
                          >Edit Link
                        </BaseTooltipButton>
                        <BaseTooltipButton
                          x-small
                          @click="$refs.linkDelete.deleteConfirm(l)"
                          iconColor="primary"
                          icon="mdi-delete"
                          >Delete Link
                        </BaseTooltipButton>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <v-row>
            <v-col class="ml-auto" cols="12" sm="auto">
              <v-text-field
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="mt-4 mr-4"> </v-col>
          </v-row> -->
      <!-- </v-card-text> -->
      <!-- <v-data-table
          :headers="filteredHeaders"
          :items="links"
          :search="searchText"
          class="pt-4"
          dense
        >
          <template v-slot:item.edit="{ item }">
          </template>
          <template v-slot:item.delete="{ item }">
          </template>
        </v-data-table> -->
      <BaseDeleteConfirm
        ref="linkDelete"
        :delete="deleteLink"
        @refresh="$emit('refresh')"
      >
        Are you sure you want to delete this link?
      </BaseDeleteConfirm>
      <LinkDialogForm ref="linkForm" @refresh="$emit('refresh')">
      </LinkDialogForm>
    </v-expansion-panels>
  </v-card>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LinkDialogForm from '@components/form/add-edit/LinkDialog'
import { authMethods, authComputed } from '@state/helpers'
export default {
  components: {
    LinkDialogForm,
  },

  props: {
    links: {
      type: Array,
      required: true,
    },
    loading: Boolean,
  },
  data: () => ({
    searchText: '',
    panel: [0],
  }),
  created() {},
  computed: {
    ...authComputed,
    ...get('trackedBill', ['selectedTrackedBill']),
    sortedLinks() {
      return this.links
        .filter((c) => true)
        .map((item) => {
          return {
            ...item,
            link: item
              ? item.URL
                ? item.URL.startsWith('http')
                  ? item.URL
                  : 'http://' + item.URL
                : ''
              : '',
          }
        })
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
    },
    userHasEditPerms() {
      return (
        this.selectedTrackedBill.currentUserPermissionID == 1 ||
        this.selectedTrackedBill.currentUserPermissionID == 2 ||
        this.selectedTrackedBill.currentUserPermissionID == 5
      )
    },
  },
  methods: {
    ...call('link', ['deleteLink']),
  },
}
</script>
<style>
.link {
  white-space: pre-wrap;
  margin: 5px;
  min-height: 50px;
  min-width: 200px;
  max-width: 85%;
  border-radius: 5px;
  padding: 4px;
  color: black;
  background-color: #dcebf3;
}
.user-link {
  /* text-align: right; */
  margin-right: 0px;
  margin-left: auto;
}
</style>
